import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";

export const AgruparLineasER = (miArray) => {
  if (miArray === undefined || miArray == null || miArray.lenght === 0)
    return [];
  var array = miArray.reduce(function (groups, item) {
    var val = item["departamento"];
    groups[val] = groups[val] || val;
    return groups;
  }, {});
  return Object.values(array);
};

export const formatoFecha = (fecha) => {
  const dia = fecha.getDate().toString().padStart(2, 0);
  const mes = fecha.getMonth() + 1;
  const año = fecha.getFullYear();

  return `${GetMonthNameByNumber(mes)} ${año}`;
};

export const GetFechaActual = (
  ejercicioinicio,
  ejerciciofin,
  periodoinicio,
  periodofin
) => {
  if (ejercicioinicio === ejerciciofin) {
    if (periodoinicio == periodofin) {
      return `${GetMonthNameByNumber(periodoinicio)} ${ejercicioinicio}`;
    } else {
      return `DE ${GetMonthNameByNumber(
        periodoinicio
      )} A ${GetMonthNameByNumber(periodofin)} ${ejercicioinicio}`;
    }
  } else {
    return `${GetMonthNameByNumber(
      periodoinicio
    )} ${ejercicioinicio} A  ${GetMonthNameByNumber(
      periodofin
    )} ${ejerciciofin}`;
  }
};

export const GetFechaActualAnterior = (
  ejercicioinicio,
  ejerciciofin,
  periodoinicio,
  periodofin
) => {
  if (ejercicioinicio === ejerciciofin) {
    if (periodoinicio == periodofin) {
      return `${GetMonthNameByNumber(periodoinicio)} ${ejercicioinicio - 1}`;
    } else {
      return `DE ${GetMonthNameByNumber(
        periodoinicio
      )} A ${GetMonthNameByNumber(periodofin)} ${ejercicioinicio - 1}`;
    }
  } else {
    var diferenciayear =
      ejerciciofin - ejercicioinicio == 0 ? 1 : ejerciciofin - ejercicioinicio;
    const difin = new Date(ejerciciofin - diferenciayear, periodofin, 1);
    const diinicio = new Date(ejercicioinicio, periodoinicio, 1);
    if (difin >= diinicio) {
      diferenciayear += 1;
    }
    return `${GetMonthNameByNumber(periodoinicio)} ${
      ejercicioinicio - diferenciayear
    } A  ${GetMonthNameByNumber(periodofin)} ${ejerciciofin - diferenciayear}`;
  }
};
